export const GoogleIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 48 48" fill="currentColor">
            <path
                fill="currentColor"
                d="M41.191 24.3988C41.191 22.9228 41.0707 21.8466 40.8121 20.7296H23.9546V27.3896H33.8489C33.65 29.0456 32.5728 31.5391 30.1788 33.2131L30.1447 33.4367L35.4746 37.5644L35.8441 37.6013C39.2356 34.4702 41.191 29.8632 41.191 24.3988Z"
            />
            <path
                fill="currentColor"
                d="M23.9546 41.9487C28.8023 41.9487 32.8712 40.3534 35.844 37.6003L30.1788 33.214C28.663 34.2703 26.628 35.0083 23.9546 35.0083C19.2064 35.0083 15.1772 31.8773 13.74 27.5497L13.5297 27.5677L7.98762 31.8555L7.91467 32.0563C10.8676 37.9205 16.9336 41.9487 23.9546 41.9487Z"
            />
            <path
                fill="currentColor"
                d="M13.74 27.5498C13.349 26.4069 13.1474 25.2079 13.1432 24C13.1432 22.7637 13.362 21.5672 13.7211 20.4502L13.7116 20.2124L8.09937 15.8555L7.91558 15.9426C6.65814 18.4425 6.00218 21.2017 6 24C6 26.8914 6.69821 29.6236 7.91463 32.0564L13.74 27.5498Z"
            />
            <path
                fill="currentColor"
                d="M23.9545 12.9916C27.3252 12.9916 29.5999 14.4477 30.8968 15.6631L35.9633 10.7179C32.8531 7.82652 28.8022 6.05115 23.9555 6.05115C16.9326 6.05115 10.8685 10.0803 7.9165 15.9426L13.721 20.4502C15.1771 16.1226 19.2063 12.9916 23.9545 12.9916Z"
            />
        </svg>
    );
};
